// Core imports
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Component imports
import { Button, Card, Col, Popconfirm, Row, Space, Tooltip, Typography } from 'antd';
import { HolderOutlined } from '@ant-design/icons';
import { EditIcon } from '../../../Icons/EditIcon';
import { DeleteIcon } from '../../../Icons/DeleteIcon';

// Misc imports
import { truncate } from '../../../../utils/string/truncate';

// Constant declarations
const { Text } = Typography;

const CarouselGridCard = ({ item, primaryBotLanguage, index, onEdit, onRemove }) => {
  const { t } = useTranslation();

  const renderCardText = (card) => {
    const buttons = card[primaryBotLanguage]?.buttons;

    return buttons?.length > 0 ? (
      <Row gutter={[8, 8]}>
        {
          buttons.map((button, index) => (
            <Col key={index} span={24}>
              <Card className="p-0 shadow-none bg-layout" bordered={false}>
                <Space.Compact style={{ minHeight: 45 }} className="px-4 justify-content-center align-items-center" direction="vertical">
                  <Text className="py-0">
                    {truncate(button?.title || '', 22, '...')}
                  </Text>

                  {
                    button?.data ? <Text type="secondary" className="fs-xs pb-1" italic>
                      {truncate(button?.data || '', 22, '...')}
                    </Text> : null
                  }
                </Space.Compact>
              </Card>
            </Col>
          ))
        }
      </Row>
    ) : (
      <Row align="middle" justify="center" style={{ minHeight: 45 }}>
        <Text type="secondary">
          {t('No buttons')}
        </Text>
      </Row>
    );
  };

  return (
    <Col className="w-100 pb-2" justify="middle">
      <Row align="middle" justify="space-between">
        <Typography.Text className="fs-sm">{index+1}</Typography.Text>

        <Col>
          <Tooltip title={t('Edit card')}>
            <Button type="link" icon={<EditIcon />} onClick={onEdit}/>
          </Tooltip>

          <Popconfirm
            title={t('Are you sure you want to delete this card?')}
            okText={t('Yes')}
            cancelText={t('No')}
            placement="topRight"
            onConfirm={onRemove}
          >
            <Tooltip title={t('Delete card')}>
              <Button type="link" icon={<DeleteIcon />} />
            </Tooltip>
          </Popconfirm>
        </Col>
      </Row>

      <Card
        className="shadow-none"
        size="small"
        title={
          <Row align="middle">
            <HolderOutlined className="mr-2" />
            <Typography.Text className="py-1 mr-2" ellipsis>{item[primaryBotLanguage]?.title}</Typography.Text>
          </Row>
        }
      >
        <Row align="middle">
          <Col span={24} align="center">
            {renderCardText(item)}
          </Col>
        </Row>
      </Card>
    </Col>
  );
};

CarouselGridCard.propTypes = {
  item: PropTypes.object.isRequired,
  primaryBotLanguage: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  onEdit: PropTypes.func,
  onRemove: PropTypes.func
};
export default CarouselGridCard;
